import { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    setDensity as setDensityAction,
    DENSITY_DEFAULT,
    DENSITY_COMPACT,
} from 'store/density/densitySlice'

// The density select dropdown is hidden in the screen width less than 767px
const MOBILE_QUERY = '(max-width: 767px)'

export default function useDensity() {
    const dispatch = useDispatch()
    const density = useSelector((state) => state.density.mode)

    const [isMobile, setIsMobile] = useState(
        () =>
            typeof window !== 'undefined' &&
            window.matchMedia(MOBILE_QUERY).matches,
    )

    useEffect(() => {
        const mql = window.matchMedia(MOBILE_QUERY)
        const handleChange = (e) => setIsMobile(e.matches)

        // Safari < 14 fallback
        if (mql.addEventListener) {
            mql.addEventListener('change', handleChange)
        } else {
            mql.addListener(handleChange)
        }

        return () => {
            if (mql.removeEventListener) {
                mql.removeEventListener('change', handleChange)
            } else {
                mql.removeListener(handleChange)
            }
        }
    }, [])

    // const effectiveDensity = isMobile ? DENSITY_DEFAULT : density
    const effectiveDensity = isMobile ? DENSITY_COMPACT : density
    
    useEffect(() => {
        document.documentElement.setAttribute('data-density', effectiveDensity)
    }, [effectiveDensity])

    const setDensity = useCallback(
        (mode) => {
            // Preference is still saved even while locked on mobile, so it
            // takes effect the moment the user goes back to desktop width.
            dispatch(setDensityAction(mode))
        },
        [dispatch],
    )

    return { density, effectiveDensity, isMobile, setDensity }
}